import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { getEntreprisesMini } from '../../context/entrepriseContext/apiCalls';
import { clientsOrEntreprises, typeEnvois, wilayas } from '../../data';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import FormRadio from '../../components/formRadio/FormRadio';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext';
import { MovementContext } from '../../context/movementContext/MovementContext';
import FormInput from '../../components/formInput/FormInput';
import { loadDecharge, submitDecharge } from '../../context/movementContext/apiCalls';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import FormTextArea from '../../components/formTextArea/FormTextArea';
import ImageLoader from '../../components/imageLoader/ImageLoader';

export default function Decharge() {
    const { dispatch, envoisMovement, count: pages, countGlobal, sumMontant, isFetchingLoad, errorLoad, message, isFetchingSubmit, errorSubmit } = useContext(MovementContext);
    const { dispatch: dispatchEntreprise, entreprisesMini } = useContext(EntrepriseContext);
    const [errorBox, setErrorBox] = useState("");

    const [clientOrEntreprise, setClientOrEntreprise] = useState(clientsOrEntreprises[1]);
    const [entreprise, setEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [username, setUsername] = useState("");

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [globalMontant, setGlobalMontant] = useState(0);
    const [globalCount, setGlobalCount] = useState(0);
    const [motif, setMotif] = useState("");
    const [fileDecharge, setFileDecharge] = useState(null);

    useEffect(() => {
        getEntreprisesMini(dispatchEntreprise);
    }, [])

    useEffect(() => {
        dispatch({ type: "CLEAR_MOVEMENT" });
        navigate('/movements/decharge');
        setErrorBox('');
        setGlobalMontant(0);
        setGlobalCount(0);
        setFileDecharge(null);
    }, [clientOrEntreprise, entreprise, username])

    useEffect(() => {
        if (clientOrEntreprise.id === 1) {
            if (entreprise.id !== 0) {
                loadDecharge(dispatch, pageSize, page, clientOrEntreprise.id, entreprise.id, null);
            }
        } else if (clientOrEntreprise.id === 2) {
            if (username !== "") {
                loadDecharge(dispatch, pageSize, page, clientOrEntreprise.id, null, username);
            }
        }
    }, [dispatch, pageSize, page])

    useEffect(() => {
        if (errorLoad !== "") {
            setErrorBox(errorLoad);
        }
        if (errorSubmit !== "") {
            setErrorBox(errorSubmit)
        }
    }, [errorLoad, errorSubmit])

    useEffect(() => {
        setGlobalMontant(sumMontant);
        setGlobalCount(countGlobal);
    }, [envoisMovement, countGlobal, sumMontant])

    useEffect(() => {
        if (message !== "") {
            dispatch({ type: "CLEAR_MOVEMENT" });
            navigate('/movements');
        }
    }, [message])

    const handleLoadDecharge = () => {
        if (clientOrEntreprise.id === 1) {
            if (entreprise.id === 0) {
                setErrorBox('Vous devez definir une Entreprise');
                return;
            }
            loadDecharge(dispatch, pageSize, page, clientOrEntreprise.id, entreprise.id, null);
        } else if (clientOrEntreprise.id === 2) {
            if (username === "") {
                setErrorBox('Vous devez compléter Username');
                return;
            }
            loadDecharge(dispatch, pageSize, page, clientOrEntreprise.id, null, username);
        }
    }

    const handleMovementDecharge = () => {
        if (clientOrEntreprise.id === 1) {
            if (entreprise.id === 0) {
                setErrorBox('Vous devez definir une Entreprise');
                return;
            }
            submitDecharge(dispatch, clientOrEntreprise.id, entreprise.id, null, globalMontant, motif, fileDecharge);
        } else if (clientOrEntreprise.id === 2) {
            if (username === "") {
                setErrorBox('Vous devez compléter Username');
                return;
            }
            submitDecharge(dispatch, clientOrEntreprise.id, null, username, globalMontant, motif, fileDecharge);
        }
    }

    // console.log(envoisMovement);
    // console.log(countGlobal);
    // console.log(sumMontant);
    // console.log(isFetchingLoad);
    // console.log(errorLoad);

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="movement" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Créer un Déchargement :</span>
                </div>

                {errorBox && <ErrorComponent error={errorBox} />}
                <div className="content invoice" style={{ marginTop: '20px' }}>
                    <div className="box" style={{ marginBottom: '20px' }}>
                        <div className="box-content">
                            {/* <FormRadio data={clientsOrEntreprises} itemChoisir={clientOrEntreprise} setItemChoisir={setClientOrEntreprise} name='tab-client-entreprise' /> */}
                            <FormRadio data={clientsOrEntreprises.filter(item=>item.id !== 1)} itemChoisir={clientOrEntreprise} setItemChoisir={setClientOrEntreprise} name='tab-client-entreprise' />
                            {
                                clientOrEntreprise.id === 1 ? (
                                    <DropDownComponent data={[{ nom: "Choisir Entreprise", id: 0 }, ...entreprisesMini]} itemChoisir={entreprise} setItemChoisir={setEntreprise} filter />
                                ) : (
                                    <FormInput label='Username' itemInput={username} setItemInput={setUsername} auth />
                                )
                            }
                            <div className='button' onClick={handleLoadDecharge}>
                                <span>Load</span>
                            </div>
                        </div>
                    </div>

                    {
                        isFetchingLoad ? <LoadingComponent /> : (
                            envoisMovement.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                : (
                                    <>
                                        <div className="box" style={{ marginBottom: '20px', minWidth: '550px', }}>
                                            <div className="box-content">
                                                <FormInput label="Nombre d'Envoie" itemInput={globalCount} setItemInput={setGlobalCount} auth inactive muted />
                                                <FormInput label='Montant Global' itemInput={globalMontant} setItemInput={setGlobalMontant} auth inactive muted />
                                                <FormTextArea label='Description' itemInput={motif} setItemInput={setMotif} auth />
                                                <ImageLoader imageLabel={"Attacher Image"} fileDecharge={fileDecharge} setFileDecharge={setFileDecharge} />
                                                <div className='button' onClick={handleMovementDecharge} style={isFetchingSubmit ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                    <span>
                                                        {isFetchingSubmit ? "Décharger ..." : "Décharger"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='movements/decharge' />
                                        <div className="content">
                                            {
                                                <>
                                                    <TableComponent headers={['Id', "Type d'Envoie", "Wilaya d'Arrivé", "Montant", "Date"]}>
                                                        {
                                                            envoisMovement.map((element, index) => (
                                                                <tr key={index}>
                                                                    <td>{element.id}</td>
                                                                    <td>{typeEnvois.filter(item => item.id === element.typeEnvoie)[0]['nom']}</td>
                                                                    <td>{wilayas.filter(item => item.id == element.wilayaArrived)[0]['nom']}</td>
                                                                    <td>{Number.parseFloat(element.montant).toFixed(2)}</td>
                                                                    <td>{element.createdAt.slice(0, 10)}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </TableComponent>
                                                    {
                                                        (pages > 1) && (<PaginationComponent page={page} pages={pages} item='movements/decharge' />)
                                                    }
                                                </>
                                            }
                                        </div>
                                    </>
                                )
                        )
                    }

                </div>
            </div>
        </div>
    )
}
